import * as React from "react";
import clsx from "clsx";
export const Ripple = (props) => {
    const { className, classes, pulsate, rippleX, rippleY, rippleSize, in: inProp, onExited, timeout, } = props;
    const [leaving, setLeaving] = React.useState(false);
    const rippleClassName = clsx(className, classes.ripple, classes.rippleVisible, {
        [classes.ripplePulsate]: pulsate,
    });
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX,
    };
    const childClassName = clsx(classes.child, {
        [classes.childLeaving]: leaving,
        [classes.childPulsate]: pulsate,
    });
    if (!inProp && !leaving) {
        setLeaving(true);
    }
    React.useEffect(() => {
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return () => {
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [onExited, inProp, timeout]);
    return (React.createElement("span", { className: rippleClassName, style: rippleStyles },
        React.createElement("span", { className: childClassName })));
};
export default Ripple;
//# sourceMappingURL=Ripple.js.map